import ServiceDeskAdminPage from "../ServiceDeskAdminPage";

export default function AdminServiceDeskPage() {
  return <ServiceDeskAdminPage embedded />;
}
